<template>
    <b-modal
        :title="quoteProduct.quoteRequested ? this.$t('createShipment.quote.quoteReceivedHeader') : this.$t('createShipment.quote.confirmHeader')"
        :ref="_uid"
        @cancel="cancel"
        :no-close-on-backdrop="true"
    >
        <div v-if="!quoteProduct.quoteRequested">
            {{ $t('createShipment.quote.confirmEmail') }}
            <b-form-group
                label-cols-sm="3"
                :label="$t('createShipment.label.Email')"
                label-align-sm="left"
            >
                <b-input-group size="sm">
                    <b-col sm="11">
                        <b-form-input
                            size="sm"
                            type="email"
                            v-model="userEmail"
                            name="requestQuoteEmail"
                            @update="$v.userEmail.$touch()"
                            :class="{ 'is-invalid': $v.userEmail.$error }"
                        />
                        <b-form-invalid-feedback v-if="$v.userEmail.$error">
                            <validationField
                                :fieldName="'createShipment.label.Email'"
                                v-if="$v.userEmail.$invalid"
                                :validator="$v.userEmail"
                                name="requestQuoteEmail.error"
                            ></validationField>
                        </b-form-invalid-feedback>
                    </b-col>
                </b-input-group>
            </b-form-group>
        </div>

        <div v-else>
            <p>{{ $t('createShipment.quote.QuoteReceivedNotificationLine1') }}</p>
            <p>{{ $t('createShipment.quote.QuoteReceivedNotificationLine2') }}</p>
            <p>{{ $t('createShipment.quote.QuoteReceivedNotificationLine3') }}</p>
            <p>{{ $t('createShipment.quote.QuoteReceivedNotificationLine4') }}</p>
        </div>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button
                v-if="!quoteProduct.quoteRequested"
                name="requestQuoteCancelButton"
                @click="cancel()"
            >Cancel</b-button>

            <b-button
                v-if="!quoteProduct.quoteRequested"
                :disabled="$v.userEmail.$error"
                @click="confirm()"
                name="requestQuoteOkButton"
                variant="primary"
            >{{ $t('core.yes') }}</b-button>

            <b-button
                v-if="quoteProduct.quoteRequested"
                name="requestQuoteCloseButton"
                @click="ok()"
                variant="primary"
            >{{ $t('core.close') }}</b-button>
        </template>
    </b-modal>
</template>
<script>
  import { mapState, mapGetters } from 'vuex';
  import { requiredIf, required, maxLength, email } from 'vuelidate/lib/validators';
  import tagManager from '../gtmEventHandler.js';

  export default {
      components: {
          validationField: () => import('./Validation/ValidationField'),
      },

      data() {
          return {
              userEmail: '',
              title: this.$t('createShipment.quote.confirmHeader'),
              quoteProduct: { quoteRequested: false },
              selected: null,
          };
      },

      mounted() {
          this.userEmail = this.$AuthService.getUserMail();
      },

      methods: {
          show(data) {
              this.quoteProduct = data.quoteProduct;
              this.selected = data.selected;

              this.$refs[this._uid].show();

              this.addGoogleAnalyticsEvent('displayRequestQuote');
          },
          confirm() {
              this.$emit('confirmAction', {
                  userEmail: this.userEmail,
                  quoteProduct: this.quoteProduct,
              });
              this.quoteProduct.quoteRequested = true;

              this.addGoogleAnalyticsEvent('requestQuote');
          },
          cancel() {
              this.addGoogleAnalyticsEvent('cancelRequestQuote');
          },

          addGoogleAnalyticsEvent(actionName) {
              tagManager.addEvent({
                  event: 'userInfo',
                  action: actionName,
                  label:
                      this.getUserData.id +
                      ',' +
                      this.quoteProduct.transportProduct +
                      ',' +
                      this.selected,
              });
          },
      },
      computed: {
          ...mapGetters('core', ['isCustomer', 'isAdminOrSuperUser', 'getUserData']),
      },
      validations: {
          userEmail: {
              required,
              email,
              maxLength: maxLength(50),
          },
      },
  };
</script>

<style></style>
